import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { getAppUrl } from '@drayalliance/utils';
import Component from './component';
import { selectAuthUserDepartment } from '../../_blessed/store/selectors/authSliceSelectors';

export default function Consumer(props) {
  const { logout } = useAuth0();

  const userDepartment = useSelector(selectAuthUserDepartment);
  const redirectURL = getAppUrl(window.location.hostname, 'accounts', 9002);
  const handleLogout = useCallback(() => {
    logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
    // appDispatch(requestLogout());
    // window.location.assign(redirectURL);
  }, [redirectURL, logout]);

  return <Component {...props} departmentType={userDepartment?.type ?? null} onLogout={handleLogout} />;
}
